<div class="container-fluid bg-light">
  <div class="row justify-content-center align-items-center vh-100">
    <div class="col-12 col-md-6 col-lg-5">
      <div class="card shadow-sm border-0 rounded-4 p-5 text-center">
        @if (loading) {
          <div class="loader mb-4"></div>
        }

        <img
          src="/images/osquare.png"
          alt="OSquare"
          width="240"
          height="auto"
          class="mb-4 mx-auto d-block"
        />

        <h3 class="mb-3">Check your email</h3>

        <p class="text-muted mb-4">
          If an OSquare account exists for
          <span class="fw-medium">{{ username }}</span
          >, we’ve sent a password reset link to the associated email address.
        </p>

        <p class="text-muted small mb-4">
          Please check your inbox (and spam folder) and follow the instructions
          to reset your password.
        </p>

        <div
          class="alert alert-warning d-flex align-items-start gap-2 small"
          role="alert"
        >
          <i class="bi bi-clock-history mt-1"></i>
          <div>
            <strong>Important:</strong>
            The password reset link is valid only for <strong>1 hour</strong>.
          </div>
        </div>

        <!-- <a routerLink="/login" class="btn btn-primary px-4"> Back to Login </a> -->
        <button
          class="btn btn-primary px-4"
          type="button"
          (click)="back.emit()"
        >
          Back to Login
        </button>
      </div>
    </div>
  </div>
</div>
